import React from "react";

interface AnimatedRainbowBorderProps {
  children: React.ReactNode;
  borderRadius?: number;
  borderWidth?: number;
  bgColor?: string;
  speed?: string;
  contentClassName?: string;
  className?: string;
  style?: React.CSSProperties;
  /** Override the drop-shadow entirely, e.g. "0 28px 80px rgba(0,0,0,0.6)" */
  shadow?: string;
  /** 0–1 multiplier on the default stroke glow opacity (default 1) */
  glowOpacity?: number;
}

const GRADIENT =
  "conic-gradient(from 0deg, #F4958E, #FFAAF7, #9193FC, #B4F6FE, #B0FFC0, #FEFF9D, #F3D9A0, #F4958E)";

const AnimatedRainbowBorder: React.FC<AnimatedRainbowBorderProps> = ({
  children,
  borderRadius = 24,
  borderWidth = 3,
  bgColor = "white",
  speed = "5s",
  contentClassName = "",
  className = "",
  style = {},
  shadow,
  glowOpacity = 1,
}) => {
  const defaultBoxShadow = `0 0 8px rgba(145,147,252,${(0.7 * glowOpacity).toFixed(2)}), 0 0 20px rgba(244,149,142,${(0.55 * glowOpacity).toFixed(2)}), 0 0 40px rgba(176,255,192,${(0.3 * glowOpacity).toFixed(2)}), 0 28px 80px rgba(0,0,0,0.28)`;
  const resolvedShadow = shadow ?? defaultBoxShadow;

  return (
    <div
      className={className}
      style={{
        position: "relative",
        borderRadius: `${borderRadius}px`,
        padding: `${borderWidth}px`,
        overflow: "hidden",
        boxShadow: resolvedShadow,
        ...style,
      }}
    >
      {/* Spinning conic-gradient — this IS the border, clipped by overflow:hidden */}
      <div
        style={{
          position: "absolute",
          inset: "-50%",
          background: GRADIENT,
          animation: `rainbow-spin ${speed} linear infinite`,
          pointerEvents: "none",
        }}
      />

      {/* Content surface */}
      <div
        className={contentClassName}
        style={{
          position: "relative",
          zIndex: 1,
          borderRadius: `${borderRadius - borderWidth}px`,
          background: bgColor,
          height: "100%",
        }}
      >
        {children}
      </div>
    </div>
  );
};

export default AnimatedRainbowBorder;
